import { ArrayInput, FormDataConsumer, SimpleFormIterator } from "react-admin";
import Inputs from "./Inputs";

export default function BadDebtInstallmentItemForm() {
  return (
    <ArrayInput
      source="bad_debt_installment_items"
      defaultValue={[
        {
          bad_debt_item_id: "",
          debt: "", // disabled
          amount: "",
        },
      ]}
    >
      <SimpleFormIterator
        disableReordering
        // getItemLabel={(index) => `#${index + 1}`}
        sx={{
          "& .RaSimpleFormIterator-form": {
            flex: 1,
          },
          "& .RaSimpleFormIterator-line": {
            borderBottom: "none",
          },
        }}
      >
        <FormDataConsumer>{Inputs}</FormDataConsumer>
      </SimpleFormIterator>
    </ArrayInput>
  );
}
